import { BaseLayout } from '@antv/g6';
export const clusterList = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
class BiLayout extends BaseLayout {
  id = 'bi-layout';

  async execute(data, options) {
    const {
      radius = 250,       // 放射状半径
      nodeSize = 32,
      centerNodeSpacing = 80,
      clusterRadius = 60  // 每个cluster内部的半径
    } = { ...this.options, ...options };

    // 找到主节点（搜索关键词或主节点）
    const mainNode = data.nodes.find(node => node.isMain || node.isSearchKeyword);
    
    // 将节点分为主节点、有cluster的节点和无cluster的节点
    const centralNodes = [];
    const clusteredNodes = [];
    const otherNodes = [];
    
    data.nodes.forEach(node => {
      if (node.isMain || node.isSearchKeyword) {
        // 主节点单独处理
        return;
      } else if (node.data?.cluster) {
        clusteredNodes.push(node);
      } else {
        otherNodes.push(node);
      }
    });

    // 按 cluster 对节点进行分组
    const clusterMap = clusteredNodes.reduce((acc, node) => {
      const cluster = node.data.cluster;
      if (!acc[cluster]) {
        acc[cluster] = [];
      }
      acc[cluster].push(node);
      return acc;
    }, {});

    const uniqueClusters = Object.keys(clusterMap);
    
    // 计算画布中心点
    const centerX = 400;
    const centerY = 300;

    const result = {
      nodes: []
    };

    // 1. 处理主节点 - 放在中心
    if (mainNode) {
      result.nodes.push({
        id: mainNode.id,
        style: {
          x: centerX,
          y: centerY,
        },
      });
    }

    // 2. 处理有cluster的节点 - 放射状排列
    if (uniqueClusters.length > 0) {
      uniqueClusters.forEach((cluster, clusterIndex) => {
        const clusterNodes = clusterMap[cluster];
        
        // 计算每个cluster组在放射状中的角度
        const clusterAngle = (2 * Math.PI * clusterIndex) / uniqueClusters.length;
        
        // 如果cluster只有一个节点，直接放在放射线上
        if (clusterNodes.length === 1) {
          result.nodes.push({
            id: clusterNodes[0].id,
            style: {
              x: centerX + radius * Math.cos(clusterAngle),
              y: centerY + radius * Math.sin(clusterAngle),
            },
          });
        } else {
          // 如果cluster有多个节点，围绕放射线上的点排列
          const clusterCenterX = centerX + radius * Math.cos(clusterAngle);
          const clusterCenterY = centerY + radius * Math.sin(clusterAngle);
          
          clusterNodes.forEach((node, nodeIndex) => {
            const nodeAngle = (2 * Math.PI * nodeIndex) / clusterNodes.length;
            result.nodes.push({
              id: node.id,
              style: {
                x: clusterCenterX + clusterRadius * Math.cos(nodeAngle),
                y: clusterCenterY + clusterRadius * Math.sin(nodeAngle),
              },
            });
          });
        }
      });
    }

    // 3. 处理其他节点 - 随机分布在外围
    otherNodes.forEach((node, index) => {
      const angle = Math.random() * 2 * Math.PI;
      const distance = radius + 100 + Math.random() * 100; // 在更外层随机分布
      result.nodes.push({
        id: node.id,
        style: {
          x: centerX + distance * Math.cos(angle),
          y: centerY + distance * Math.sin(angle),
        },
      });
    });

    return result;
  }
}

export default BiLayout;
